// src/components/products/ProductForm/TourDetailsSections/TourTransferAreasSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const TourTransferAreasSection = ({
    formData,
    errors,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Free Transfer Areas - Arabic */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="مناطق النقل المجاني (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="free_transfer_areas_ar"
                        value={formData.free_transfer_areas?.ar || ''}
                        onChange={(e) => handleMultiLangChange('free_transfer_areas', 'ar', e.target.value)}
                        rows={3}
                        error={!!errors.free_transfer_areas_ar}
                        helperText={errors.free_transfer_areas_ar}
                    />
                </Grid>
            )}

            {/* Free Transfer Areas - English */}
            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Free Transfer Areas (English)"
                        type="editor"
                        textareaRows={200}
                        name="free_transfer_areas_en"
                        value={formData.free_transfer_areas?.en || ''}
                        onChange={(e) => handleMultiLangChange('free_transfer_areas', 'en', e.target.value)}
                        rows={3}
                        error={!!errors.free_transfer_areas_en}
                        helperText={errors.free_transfer_areas_en}
                    />
                </Grid>
            )}

            {/* Extra Charge Transfer Areas - Arabic */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="مناطق النقل برسوم إضافية (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="extra_charge_transfer_areas_ar"
                        value={formData.extra_charge_transfer_areas?.ar || ''}
                        onChange={(e) => handleMultiLangChange('extra_charge_transfer_areas', 'ar', e.target.value)}
                        rows={3}
                        error={!!errors.extra_charge_transfer_areas_ar}
                        helperText={errors.extra_charge_transfer_areas_ar}
                    />
                </Grid>
            )}

            {/* Extra Charge Transfer Areas - English */}
            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Extra Charge Transfer Areas (English)"
                        type="editor"
                        textareaRows={200}
                        name="extra_charge_transfer_areas_en"
                        value={formData.extra_charge_transfer_areas?.en || ''}
                        onChange={(e) => handleMultiLangChange('extra_charge_transfer_areas', 'en', e.target.value)}
                        rows={3}
                        error={!!errors.extra_charge_transfer_areas_en}
                        helperText={errors.extra_charge_transfer_areas_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default TourTransferAreasSection;
